import type { CreateMasterDataItemInput, CreatePlantInput, MasterDataItem, Plant, UpdateMasterDataItemInput, UpdatePlantInput } from '@container-system/shared';
import { apiRequest } from './client';

function makeResource(basePath: string) {
  return {
    list: () => apiRequest<MasterDataItem[]>(basePath),
    create: (input: CreateMasterDataItemInput) => apiRequest<MasterDataItem>(basePath, { method: 'POST', body: JSON.stringify(input) }),
    update: (id: string, input: UpdateMasterDataItemInput) =>
      apiRequest<MasterDataItem>(`${basePath}/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
    remove: (id: string) => apiRequest<null>(`${basePath}/${id}`, { method: 'DELETE' }),
  };
}

export const containersApi = makeResource('/api/containers');
export const materialsApi = makeResource('/api/materials');
export const alloysApi = makeResource('/api/alloys');
export const driversApi = makeResource('/api/drivers');

export const plantsApi = {
  list: () => apiRequest<Plant[]>('/api/plants'),
  create: (input: CreatePlantInput) => apiRequest<Plant>('/api/plants', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: string, input: UpdatePlantInput) => apiRequest<Plant>(`/api/plants/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  remove: (id: string) => apiRequest<null>(`/api/plants/${id}`, { method: 'DELETE' }),
};
